import { useEffect, useState } from "react";
import { messaging, onMessage } from "./firebaseConfigWeb";

const useFCMListener = () => {
  const [notifications, setNotifications] = useState<{ title: string; body: string }[]>([]);

  useEffect(() => {
    
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Received a push notification:", payload);

      const title = payload.notification?.title || "New Notification";
      const body = payload.notification?.body || "You have a new message";

      setNotifications((prev) => [...prev, { title, body }]);
    });

    return () => unsubscribe();
  }, []);

  return notifications;
};

export default useFCMListener;
